<template>
  <div class="bg-genialguard">
    <div class="container text-white">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4 genialguard-logo" src="@/assets/logo_genial_guard.png">
        <h1>
          Você escolheu o plano:
        </h1>
        <h1>
          <strong>
            <span class="plan-title">{{ plan.name }} - Anual - </span>
            <span class="plan-title">{{installments}}X R$ {{ formatMoney(plan.yearlyValue / installments, 2) }}</span>
          </strong>
        </h1>
      </div>

      <div class="row">
        <div class="col-md-8" v-if="plan">
          <p class="price-text-1 mb-0">Tudo por:</p>
          <p class="price-text-2">{{installments}}X R$ {{ formatMoney(plan.yearlyValue / installments, 2) }}</p>

          <div class="card p-3" v-if="loading">
            <div class="text-center">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
              <h6 class="mb-0 mt-2 font-weight-bold text-black">Carregando...</h6>
            </div>
          </div>

          <div class="row card" v-if="step === 'data' && !loading">
            <form class="text-black needs-validation p-3" @submit.prevent="changeStep('payment')">
              <h2 class="form-heading">Comece aqui</h2>

              <div class="row px-3">
                <div class="col-md-6 mb-3">
                  <label for="firstName">Seu Nome</label>
                  <input type="text" class="form-control" id="firstName" placeholder="" value="" required="" v-model="account.name">
                  <div class="invalid-feedback">
                    Valid first name is required.
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="email">Seu e-mail</label>
                  <div class="input-group">
                    <input type="text" class="form-control" id="email" placeholder="" required="" autocomplete="username" v-model="account.email">
                    <div class="invalid-feedback">
                      O email não pode ser vazio.
                    </div>
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="cpf">CPF</label>
                  <the-mask type="text" id="cpf" class="form-control" placeholder="" value="" required="" v-model="account.cpf" :mask="'###.###.###-##'" :masked="false" />
                  <div class="invalid-feedback">
                    CPF necessário
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="phone">Telefone</label>
                  <the-mask
                    type="text"
                    class="form-control"
                    id="phone" placeholder=""
                    value=""
                    required=""
                    v-model="account.phoneNumber"
                    :mask="['(##) ####-####', '(##) #####-####']"
                    :masked="false"
                  />
                  <div class="invalid-feedback">
                    Telefone necessário
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="state">Estado</label>
                  <b-form-select v-model="account.state" :options="stateOptions"></b-form-select>
                  <div class="invalid-feedback">
                    Estado necessário
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="city">Cidade</label>
                  <input type="text" class="form-control" id="city" placeholder="" value="" required="" v-model="account.city">
                  <div class="invalid-feedback">
                    Cidade necessário
                  </div>
                </div>
                <div class="col-md-4 mb-3">
                  <label for="neighborhood">Bairro</label>
                  <input type="text" class="form-control" id="neighborhood" placeholder="" value="" required="" v-model="account.neighborhood">
                  <div class="invalid-feedback">
                    Bairro obrigatório
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label for="street">Rua</label>
                  <input type="text" class="form-control" id="street" placeholder="" value="" required="" v-model="account.street">
                  <div class="invalid-feedback">
                    Rua necessária
                  </div>
                </div>
                <div class="col-md-2 mb-3">
                  <label for="streetNumber">Número</label>
                  <input type="text" class="form-control" id="streetNumber" placeholder="" value="" required="" v-model="account.streetNumber">
                  <div class="invalid-feedback">
                    Número necessário
                  </div>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="zipcode">CEP</label>
                  <the-mask class="form-control" id="zipcode" placeholder="" v-model="account.zipcode" :mask="'#####-###'" :masked='false'/>
                  <div class="invalid-feedback">
                    CEP necessário
                  </div>
                </div>
                <!-- <div class="col-md-4 mb-3">
                  <label for="password">Senha</label>
                  <input type="password" class="form-control" id="password" autocomplete="password" placeholder="" value="" required="" v-model="account.password" >
                </div>
                <div class="col-md-4 mb-3">
                  <label for="confirmPassword">Confirmação de senha</label>
                  <input type="password" class="form-control" id="confirmPassword" autocomplete="password" placeholder="" value="" required="" v-model="account.confirmPassword">
                </div> -->
              </div>
  
              <div class="row px-3">
                <div class="col-md-4 mb-3">
                  <label for="payment-method">Forma de Pagamento:</label>    
                  <select id="payment-method" class="form-control payment-select" v-model="paymentMethod">
                    <option value="CREDIT_CARD">Cartão de Crédito</option>
                    <option value="PIX">PIX</option>
                  </select>
                </div>
                <div class="col-md-4 mb-3" v-if="paymentMethod === 'CREDIT_CARD'">
                  <label for="page-customer-installments">Quantidade de Parcelas:</label>    
                  <select id="page-customer-installments" class="form-control payment-select" v-model="installments">
                    <option v-for="index in 12" :key="index" :value="index">{{index}}x R$ {{ formatMoney(plan.yearlyValue / index, 2) }}</option>
                  </select>
                </div>
              </div>

              <div class="col-12 m-auto">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="termsAndConditions"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Declaro que li e aceito os <b-link class="text-secondary" v-b-modal.modal-1>termos de uso da plataforma.</b-link class="secondary">
                </b-form-checkbox>
              </div>

              <div class="col-md-4 m-auto p-5">
                <button class="btn btn-genialguard btn-lg btn-block text-center" type="submit">Próximo </button>
              </div>
            </form>
          </div>

          <div class="row card" v-if="step === 'payment' && !loading">
            <div class="p-3" v-if="paymentMethod === 'PIX' && pix">
              <p class="copy-and-paste" @click="copyToClipboard(pix.copyAndPaste)">
                <span class="bold">Copia e cola:</span> <span id="copy-and-paste">{{ pix.copyAndPaste }}</span>
              </p>
              <div class="text-center">
                <img :src="'data:image/png;base64,' + pix.qrCode" />
              </div>
              <a class="btn btn-secondary" href="/login">Ir para Login</a>
            </div>
            <form class="text-black needs-validation p-3" @submit.prevent="register" v-if="paymentMethod === 'CREDIT_CARD'">
              <div class="row px-3">
                <div class="col-md-12 mb-3">
                  <label for="card">Nome no Cartão</label>
                  <input type="text" class="form-control" id="card" placeholder="" value="" required="" v-model="payment.name">
                  <div class="invalid-feedback">
                    Valid name is required.
                  </div>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="phone">Número do Cartão</label>
                  <the-mask
                    type="text"
                    class="form-control"
                    id="phone" 
                    placeholder=""
                    value=""
                    required=""
                    v-model="payment.number"
                    :mask="['#### #### #### ####']"
                    :masked="false"
                  />
                  <div class="invalid-feedback">
                    Número do cartão necessário
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="card">Validade (Mês)</label>
                  <input type="text" class="form-control" id="card" placeholder="" value="" required="" v-model="payment.expiryMonth">
                  <div class="invalid-feedback">
                    Valid month is required.
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="card">Validade (Ano)</label>
                  <input type="text" class="form-control" id="card" placeholder="" value="" required="" v-model="payment.expiryYear">
                  <div class="invalid-feedback">
                    Valid year is required.
                  </div>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="card">CVV</label>
                  <input type="text" class="form-control" id="card" placeholder="" value="" required="" v-model="payment.ccv">
                  <div class="invalid-feedback">
                    CVV is required.
                  </div>
                </div>

                <div class="col-12 m-auto">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="termsAndConditions"
                    name="checkbox-1"
                    value="accepted"
                    unchecked-value="not_accepted"
                  >
                    Declaro que li e aceito os <b-link class="text-secondary" v-b-modal.modal-1>termos de uso da plataforma.</b-link class="secondary">
                  </b-form-checkbox>
                </div>

                <div class="col-md-4 m-auto p-5">
                  <button class="btn btn-genialguard btn-lg btn-block text-center" type="submit">Finalizar Cadastro </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-4 my-5">
          <div class="my-5"></div>

          <div>
            <h5 class="title">
              <span>Garantia</span> <br /> 
              <span>Estorno automático</span>
            </h5>
            <p class="description">Fique 100% confiante ao testar com garantia de dinheiro de volta. É só solicitar dentro do programa no prazo da garantia.</p>
          </div>

          <div>
            <h5 class="genialguard-title"><span></span>ASSINATURA RECORRENTE. <br /> <span>ALTERE OU CANCELE QUANDO QUISER</span></h5>
            <p class="description">Mude seu plano quando quiser. Sem fidelidade, sem letras miúdas. Risco zero.</p>
          </div>
        </div>
      </div>
      <div>
        <b-modal id="modal-1" title="TERMOS DE USO DOS SERVIÇOS ORIENTA LEGAL LTDA.">
          <TermsAndConditions />
        </b-modal>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from 'components/Footer';
import TermsAndConditions from 'components/TermsAndConditions';
import { mapGetters } from 'vuex';
import { getPlan } from '../services/plans';
import { subscribe } from '../services/accounts';
import { getIPAddress } from '../utils/common';
import { registerGenialGuard } from '../services/genialGuard';

export default {
  name: 'GenialGuardRegister',
  computed: mapGetters(['authstatus', 'authErrorMessage']),
  data() {
    return {
      loading: false,
      stateOptions: [
        { value: null, text: 'Por favor, selecione uma opção' },
        // All Brazil states
        { value: 'AC', text: 'Acre' },
        { value: 'AL', text: 'Alagoas' },
        { value: 'AP', text: 'Amapá' },
        { value: 'AM', text: 'Amazonas' },
        { value: 'BA', text: 'Bahia' },
        { value: 'CE', text: 'Ceará' },
        { value: 'DF', text: 'Distrito Federal' },
        { value: 'ES', text: 'Espírito Santo' },
        { value: 'GO', text: 'Goiás' },
        { value: 'MA', text: 'Maranhão' },
        { value: 'MT', text: 'Mato Grosso' },
        { value: 'MS', text: 'Mato Grosso do Sul' },
        { value: 'MG', text: 'Minas Gerais' },
        { value: 'PA', text: 'Pará' },
        { value: 'PB', text: 'Paraíba' },
        { value: 'PR', text: 'Paraná' },
        { value: 'PE', text: 'Pernambuco' },
        { value: 'PI', text: 'Piauí' },
        { value: 'RJ', text: 'Rio de Janeiro' },
        { value: 'RN', text: 'Rio Grande do Norte' },
        { value: 'RS', text: 'Rio Grande do Sul' },
        { value: 'RO', text: 'Rondônia' },
        { value: 'RR', text: 'Roraima' },
        { value: 'SC', text: 'Santa Catarina' },
        { value: 'SP', text: 'São Paulo' },
        { value: 'SE', text: 'Sergipe' },
        { value: 'TO', text: 'Tocantins' },
      ],
      account: {
        name: '',
        email: '',
        phoneNumber: '',
        state: '',
        city: '',
        neighborhood: '',
        street: '',
        streetNumber: '',
        zipcode: '',
        // password: '',
        // confirmPassword: ''
      },
      payment: {
        name: '',
        number: '',
        expiryMonth: '',
        expiryYear: '',
        ccv: '',
        type: 'CREDIT_CARD'
      },
      termsAndConditions: 'not_accepted',
      plan: null,
      installments: 12,
      step: 'data',
      userIP: '',
      paymentInfo: null,
      paymentMethod: 'CREDIT_CARD',
    };
  },
  methods: {
    async getPlanById(planId) {
      const plan = await getPlan(planId);
      this.plan = plan;
    },

    async changeStep(step) {
      const isValid = this.formValidation();

      if (!isValid) return;

      if (this.paymentMethod === 'PIX') {
        await this.register();
      }

      this.step = step;
    },

    formValidation() {
      const { account } = this;

      if (this.termsAndConditions === 'not_accepted') {
        this.$toast.open({
          message: 'Você precisa aceitar os termos de uso',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.name) {
        this.$toast.open({
          message: 'Nome obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.email) {
        this.$toast.open({
          message: 'Email obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.phoneNumber) {
        this.$toast.open({
          message: 'Telefone obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.email) {
        this.$toast.open({
          message: 'Email obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.state) {
        this.$toast.open({
          message: 'Estado obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.city) {
        this.$toast.open({
          message: 'Cidade obrigatória',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.neighborhood) {
        this.$toast.open({
          message: 'Bairro obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.street) {
        this.$toast.open({
          message: 'Rua obrigatória',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (!account.streetNumber) {
        this.$toast.open({
          message: 'Número obrigatório',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      if (account.zipcode?.length < 8) {
        this.$toast.open({
          message: 'CEP inválido',
          type: 'error',
          position: 'top-right'
        });
        return false;
      }

      // if (!account.password) {
      //   this.$toast.open({
      //     message: 'Senha obrigatória',
      //     type: 'error',
      //     position: 'top-right'
      //   });
      //   return false;
      // }

      // if (account.password !== account.confirmPassword) {
      //   this.$toast.open({
      //     message: 'Confirmação de senha inválida.',
      //     type: 'error',
      //     position: 'top-right'
      //   });
      //   return false;
      // }

      return true;
    },

    async register() {
      this.loading = true;

      const { account } = this;

      const data = {
        "account": account,
        "planId": this.plan.id,
        "creditCard": {
          "holderName": this.payment.name,
          "number": this.payment.number,
          "expiryMonth": this.payment.expiryMonth,
          "expiryYear": this.payment.expiryYear,
          "ccv": this.payment.ccv
        },
        "creditCardHolderInfo": {
          "name": account.name,
          "email": account.email,
          "cpfCnpj": account.cpf,
          "postalCode": account.zipcode,
          "addressNumber": account.streetNumber,
          "addressComplement": `${account.neighborhood} ${account.street}`,
          "phone": account.phoneNumber,
          "mobilePhone": ""
        },
        "installmentNumber": this.installments,
        "IP": this.userIP,
        "paymentType": this.paymentMethod
      };

      try {
        // this.$toast.open({
        //   message: 'EM DESENVOLVIMENTO',
        //   type: 'info',
        //   position: 'top-right'
        // });

        // this.loading = false;
        // return;
        
        const response = await registerGenialGuard(data);

        if (response.pix) {
          this.pix = response.pix;
        }
        
        this.$toast.open({
          message: 'Recebemos seu pedido! Agora é só concluir o pagamento para liberar o acesso. Assim que o sistema confirmar, você receberá a liberação automática por e-mail',
          type: 'success',
          position: 'top-right'
        });
        this.$router.push('/genialguard-plans');
      } catch (err) {
        console.info('reg err', err.response);
        
        let errorMessage = 'Erro ao se cadastrar. Por favor, verifique seus dados e tente novamente.';

        const error = err?.response?.data?.message || err?.response?.data?.err || '';

        if (error.includes('O CPF/CNPJ informado é inválido.')) {
          errorMessage = 'Erro ao se cadastrar. O CPF/CNPJ informado é inválido.';
        }

        if (error.includes('EmailAlreadyExistsError')) {
          errorMessage = 'Email já cadastrado. Entre em contato para mais informações.';
        }

        if (error.includes('InvalidEmailError')) {
          errorMessage = 'Erro ao se cadastrar. O email informado é inválido.';
        }

        if (error.includes('UniqueViolationError user_email_unique')) {
          errorMessage = 'Erro ao se cadastrar. Email já cadastrado.';
        }
        
        this.step = 'data';
        this.$toast.open({
          message: errorMessage,
          type: 'error',
          position: 'top-right'
        });
      }
      
      this.loading = false;
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.$toast.open({
        message: 'Código copia e cola copiado.',
        type: 'info',
        position: 'bottom-right',
      });
    },

    formatMoney(value, digits) {
      const d = digits !== undefined ? digits : 2;
      const nf = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
      });
      return nf.format(value);
    },
  },
  watch: {
    paymentMethod(newValue) {
      if (newValue === 'PIX') {
        this.installments = 1;
      }
    }
  },
  async created() {
    this.plan = this.$route.params.plan;

    this.userIP = await getIPAddress();

    if (this.$route.query.planId) {
      try {
        this.plan = await getPlan(this.$route.query.planId, { allOptions: true });
      } catch (err) {}
    }

    if (!this.plan) {
      this.$router.push({ name: 'genialGuardPlans' });
    }
  },
  components: {
    Footer,
    TermsAndConditions,
  }
}
</script>

<style>
@media screen and (max-width: 768px) {
  .mobile-class {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

.copy-and-paste {
  color: black;
  cursor: pointer;
}

.text-black {
  color: black;
}

.plan-title {
    margin-left: 5px;
    color: #3F87F5;
}

.price-text-1 {
    line-height: normal;
    font-size: .75rem;
    text-align: left;
}

.price-text-2 {
    line-height: 40px;
    font-size: 30px;
    text-align: left;
}

.form-heading {
  box-sizing: border-box;
    margin: 10px;
    flex: 3.5 0 0%;
    font-weight: bolder;
    line-height: 24px;
    font-size: 17px;
    text-transform: uppercase;
    color: #333;
}

.payment-select {
    padding: 8px 16px 8px 8px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5%;
}

.genialguard-title {
  border-left: 7px solid #3F87F5;
  padding-left: 10px;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  line-height: 1.4rem;
}

.description {
  margin-left: 1rem;
    color: #ffec7d;
    text-align: left;
    font-weight: 200;
    line-height: 1.25rem;
    margin-bottom: 20px;
}

.genialguard-logo {
  width: 180px;
  height: auto;
}

.bg-genialguard {
  background: #0E1B2B !important;
}

.btn-genialguard {
  background-color: #3F87F5;
  border: 3px solid #3F87F5;
  border-radius: 4px;
  text-transform: uppercase;
  color: #FFF;
  font-weight: 800;
  padding: 10px 20px;
}

.btn-genialguard:hover {
  background-color: #2d6fd8;
  border-color: #2d6fd8;
  color: #FFF;
}

.text-12 {
    font-size: .75rem !important;
}

.text-16 {
    font-size: 1em !important;
    line-height: 1.3 !important;
    font-weight: 400;
}

.text-24 {
  font-size: 1.5rem !important;
}

.text-32 {
    font-size: 32px;
    line-height: 40px;
}

.text-orange {
  color: #ed7b02;
}

.text-dark-blue {
    color: #363f5e;
}

.text-light-gray {
    color: #999999;
}
</style> 